import './documentsList.css';
import { ChevronRightIcon, CreditCardIcon, DocumentIcon, IdentificationIcon } from '@heroicons/react/24/solid';
import GlobalConfig from '../context/GlobalConfig';
import { residentIDCardName, drivingLicenceName, idCardName } from "../constants/countries";
import { useContext, useState } from 'react';
import GoogleIcon from './GoogleIcon';

// Keyed by the lowercased label as it appears in the picker. A document verified without being
// captured is still that document, so its no-doc label needs its own key here — otherwise it falls
// through to the generic id_card icon and reads as a different document to the applicant.
const lists = {
    "passport": <GoogleIcon iconName="credit_card" size={24} />,
    "driving license": <GoogleIcon iconName="directions_car" size={24} />,
    "driving license verification": <GoogleIcon iconName="directions_car" size={24} />,
    "pan": <GoogleIcon iconName="money" size={24} />,
    // "aadhaar": <GoogleIcon iconName="id_card" size={24} />,
    // "voter id card": <IdentificationIcon />,
    // "visa": <CreditCardIcon />,
    // "social security card": <CreditCardIcon />,
    // "permanent resident card": <DocumentIcon />,
    // "alien registration card": <IdentificationIcon />,
    // "department of state tax card": <DocumentIcon />,
    // "employment authorization card": <CreditCardIcon />,
    // "other id card": <DocumentIcon />,
    // "armed forces id card": <CreditCardIcon />,
    // "certificate for eu citizen": <CreditCardIcon />,
    // "Driving License abu dhabi": <IdentificationIcon />,
    // "Driving License ajman": <CreditCardIcon />,
    // "Driving License ras al khaimah": <IdentificationIcon />,
    // "Driving License umm al quwain": <DocumentIcon />,
    // "dubai driving license": <DocumentIcon />,
    // "e-card": <CreditCardIcon />,
    // "epassport": <IdentificationIcon />,
    // "id card": <CreditCardIcon />,
    // "residence id card": <DocumentIcon />,
    // "sharjah driving license": <IdentificationIcon />
};

const DocumentsList = ({ list, handleNext, docSelected, countryCode, countryName }) => {
    const { config } = useContext(GlobalConfig);
    const color = config?.branding?.accentColor
    // const bgColor = 'color-mix(in srgb, ' + config?.branding?.accentColor + ' 10%, white)'
    const bgColor =
        `color-mix(in srgb, ${config?.branding?.accentColor} 5%, white 95%)`;
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className='documentListContainer'>
            {list.map((item, index) => (
                <div key={index} className={item.documentType === docSelected ? "borderBoxSelected" : "borderBox"} onClick={() => handleNext(item)} onMouseEnter={() => setHoveredIndex(index)} // Set the hovered index on mouse enter
                    onMouseLeave={() => setHoveredIndex(null)}  // Reset the hovered index on mouse leave
                    style={{
                        backgroundColor: hoveredIndex === index ? bgColor : 'transparent', // Apply red if hovered

                    }}>
                    <div className='flex items-center'>
                        {/* shrink-0: without it the flex row squeezes the icon narrower as the
                            label grows, so a two-line name left a visibly flattened circle. */}
                        <div className="left-0 top-0 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-indigo-600 text-white " style={{ background: bgColor, color: color, borderRadius: '20px' }}>
                            <div className='h-6 w-6 shrink-0'>
                                {lists[item.toLowerCase()] ?? <GoogleIcon iconName="id_card" size={24} />}
                            </div>
                        </div>
                        <div className='ml-6'>
                            <p className='font-semibold ' value={item}>
                                {
                                    (() => {
                                        // Normalize item for case-insensitive matching
                                        const normalizedItem = item?.toLowerCase().trim();
                                        
                                        // Check for Resident ID Card variations
                                        if (normalizedItem === 'resident id card' || normalizedItem === 'resident idcard') {
                                            return residentIDCardName?.[countryCode] ? residentIDCardName?.[countryCode] : "Identity Card";
                                        }
                                        
                                        // Check for ID Card variations (Id Card, ID Card, Identity Card)
                                        if (normalizedItem === 'id card' || normalizedItem === 'idcard' || normalizedItem === 'identity card') {
                                            // For Palestine, use consistent "ID Card" name
                                            if (countryCode === 'PS') {
                                                return 'ID Card';
                                            }
                                            return idCardName?.[countryCode] ? idCardName?.[countryCode] : item;
                                        }
                                        
                                        // Check for Other ID Card (Health Insurance Card for Palestine)
                                        if (normalizedItem === 'other id card' || normalizedItem === 'other idcard') {
                                            if (countryCode === 'PS') {
                                                return 'Other ID Card';
                                            }
                                            return item;
                                        }
                                        
                                        // Check for Passport
                                        if (normalizedItem === 'passport') {
                                            return `${countryName} Passport`;
                                        }
                                        
                                        // Check for Driving License
                                        if (normalizedItem === 'driving license' || normalizedItem === 'driving licence') {
                                            return drivingLicenceName?.[countryCode] ? drivingLicenceName?.[countryCode] : item;
                                        }
                                        
                                        // Default: return item as-is
                                        return item;
                                    })()
                                }
                            </p>
                        </div>
                    </div>
                    <div className='shrink-0 ml-2'>
                        <ChevronRightIcon height={20} />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default DocumentsList;